import { userDisplayName } from './userDisplay'

export function organizerLabel(organizer) {
  if (organizer.kind === 'user') return userDisplayName(organizer.user)
  return organizer.name || ''
}

export function formatOrganizersSummary(organizers) {
  const labels = organizers.map(organizerLabel).filter(Boolean)
  if (labels.length <= 2) return labels.join(', ')
  return `${labels.slice(0, 2).join(', ')} ещё ${labels.length - 2}`
}

export function contactHref(contact) {
  if (!contact) return null

  const trimmed = contact.trim()
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return `mailto:${trimmed}`
  if (/^\+?[\d\s().-]{7,}$/.test(trimmed)) return `tel:${trimmed.replace(/\s/g, '')}`

  return null
}

export function organizersFromApi(organizers, ownerId) {
  return (organizers || [])
    .filter((item) => !(item.kind === 'user' && item.user?.id === ownerId))
    .map((item) => {
      if (item.kind === 'user') return { user: item.user }
      return { id: item.id, name: item.name, contact: item.contact }
    })
}

export function organizersToApi(organizers) {
  return organizers.map((item) => {
    if (item.user) return { user_id: item.user.id }
    return { id: item.id, name: item.name, contact: item.contact }
  })
}
